import React from 'react';

import { isArray } from 'lodash/fp';
import PropTypes from 'prop-types';
import { Redirect, Route, useHistory } from 'react-router-dom';
import auth from 'services/Auth';

const RouteForBUs = ({ allowedBUs, redirectTo = '/dashboard', render, ...attr }) => {
  const history = useHistory();

  const redirrectToDashboard = (
    <Redirect
      to={{
        pathname: redirectTo,
        state: { from: history.from },
      }}
    />
  );

  return (
    <Route
      {...attr}
      render={props => {
        const userBU = auth.getContactInfo().company.code.toLowerCase();
        const BUs = isArray(allowedBUs) ? allowedBUs : [allowedBUs];

        try {
          return userBU.includes(BUs) ? render(props) : redirrectToDashboard;
        } catch (error) {
          console.error('Unknown BU');

          return redirrectToDashboard;
        }
      }}
    />
  );
};

RouteForBUs.propTypes = {
  render: PropTypes.func.isRequired,
};

export default RouteForBUs;
